import React from 'react';

function Header(props) {
  return <div className="in-page-header  flex aic"> {props.children} </div>;
}

export default Header;
